<template>
    <fade-loader v-bind="fadeLoader">
        <v-data-table
                class="sr-table"
                :headers="selectedHeaders"
                :items="items"
                :server-items-length="totalItems"
                :page.sync="pagination.page"
                :items-per-page.sync="pagination.rowsPerPage"
                :loading="loading"
                :options.sync="tableOptions"
                item-key="key"
                hide-default-footer
        >
            <template #no-data>
                Keine Daten gefunden
            </template>
            <template #item="props">
                <tr @click="rowClicked(props.item)" :class="{'active': activeItem === props.item}">
                    <td v-for="itemInfo in selectedHeaders" :key="itemInfo.key"
                        :class="{'text-right': itemInfo.align === 'right', 'text-left': itemInfo.align==='left'}">
                        <!--{{ props.item | getFieldValue(itemInfo) }}-->
                        <dynamic-row
                                :item="props.item"
                                :field="itemInfo"
                        >
                        </dynamic-row>
                    </td>
                </tr>
            </template>

            <template #footer>
                <div class="sr-pagination">
                    <div class="left">
                        <v-progress-circular v-if="exportLoading === true" :size="16" :width="2" color="#2ED1DF" indeterminate></v-progress-circular>
                        <v-menu offset-y left class="sr-dropdown" v-else>
                            <template #activator="{ on }">
                                <button v-on="on" class="btn-icon icon-download"></button>
                            </template>
                            <v-list>
                                <v-list-item
                                        v-for="(item, index) in exportOptions"
                                        :key="index"
                                        @click="exportData(item)"
                                >
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="middle">
                        <pagination :length="totalItems" v-model="pagination"></pagination>
                    </div>
                    <div class="right" ref="container">

                        <v-menu
                                :close-on-content-click="false"
                                offset-y
                        >
                            <template #activator="{ on }">
                                <button class="btn-icon icon-columns" v-on="on"></button>
                            </template>

                            <v-list class="maxHeight scroll-y">
                              <v-list-item>
                                <text-field  onlyField v-model="localColumnSearch" placeholder="Suche..." style="width: 100%;"/>
                              </v-list-item>

                              <v-list-item v-for="(header, key) in columnOptions" :key="key">
                                    <template v-if="typeof header.header === 'undefined'">
                                        <checkbox :value="isHeaderSelected(header.key)"
                                                  @input="selectHeader(header)"
                                                  :label="header.text"
                                                  :disabled="header.disabled === true"
                                                  class="sr-checkbox">
                                        </checkbox>
                                    </template>
                                    <template v-else>
                                        {{header.header}}
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <!--<v-menu
                                :close-on-content-click="false"
                                offset-y
                        >
                            <template #activator="{ on }">
                                <button class="btn-icon icon-columns" v-on="on"></button>
                            </template>

                            <v-list class="maxHeight scroll-y">
                                <v-list-item v-for="(header, key) in options.headers" :key="key">
                                    <v-list-item-action>
                                        <v-checkbox :input-value="header.default" @change="selectHeader(header)" :disabled="header.disabled"></v-checkbox>
                                    </v-list-item-action>

                                    <v-list-item-content @click="selectHeader(header)">
                                        <v-list-item-title>{{ header.text }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>-->
                    </div>
                </div>
            </template>
        </v-data-table>
    </fade-loader>
</template>

<script>
  import _ from 'lodash'
  import Pagination from '@/components/Pagination'
  import GeoObject from '@/models/GeoObject'
  import axios from 'axios'

  export default {
    components: { Pagination },
    props: ['options', 'apiCall', 'activeItem', 'filter', 'export-loading'],
    data () {
      return {
        showExportOptions: false,
        exportOptions: [
          {
            type: 'csv',
            title: 'CSV Export'
          },
          {
            type: 'shp',
            title: 'Shape File Export'
          }
        ],
        openColumnSelect: false,
        search: '',
        selectedHeaders: [],
        items: [],
        totalItems: 0,
        loading: true,
        sortBy: null,
        sortDescending: null,
        tableOptions: {},
        pagination: {
          page: 1,
          rowsPerPage: 10
        },
        localColumnSearch: ''
      }
    },
    mounted () {
      // setting default headers
      _.forEach(this.options.headers, item => {
        if (typeof item.default !== 'undefined' && item.default === true) {
          this.selectedHeaders.push(item)
        }
      })

      this.$resolve(this.loadData())
    },
    filters: {
      /**
       * @param {GeoObject} item,
       * @param {Object} config
       * @param {Number} config.layerId
       */
      getFieldValue (item, config) {
        // grab the correct object
        let object = null

        if (item.layer === config.layerId) {
          object = item
        } else if (Array.isArray(item.objects)) {
          // search for objects
          object = item.objects.find((el) => el.layer === config.layerId)
        }

        if (object) {
          if (typeof config.value === 'function') {
            return config.value(object)
          }

          return object[config.value]
        }

        return ''
      }
    },
    methods: {
      getLayer (header) {
        return this.$store.getters['layer/get'](header.layerId)
      },
      getDynamicHeaderName (header) {
        return 'header.' + header.value
      },
      exportData (item) {
        this.$emit('export', { type: item.type, headers: this.selectedHeaders })
      },
      isHeaderSelected (item) {
        return typeof this.selectedHeaders.find(el => el.key === item) !== 'undefined'
      },
      rowClicked (item) {
        this.$emit('click', item)
      },
      async loadData () {
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()

        if (this.loading && this.lastCancelSource) {
          // cancel old request
          this.lastCancelSource.cancel('Operation canceled by the user.')
        }

        this.lastCancelSource = source

        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions
        if (!page || !itemsPerPage) {
          return
        }
        let response = null
        try {
          response = await this.apiCall(page, itemsPerPage, this.filter, { sortBy, sortDesc }, { cancelToken: source.token })
        } catch (error) {
          if (axios.isCancel(error)) {
            // abbruch durch uns
            return
          }

          this.loading = false
          this.items = []
          this.$alert.error('Laden der Liste fehlgeschlagen')
          return
        }
        this.items = []// response.data.items
        let promises = []
        let items = []
        response.data.items.forEach((el) => {
          const item = new GeoObject(el)
          promises.push(item.loadingPromise)
          items.push(item)
        })
        Promise.all(promises).then(() => {
          this.items = items
          this.loading = false
        })
        this.totalItems = response.data.total
      },
      selectHeader (header) {
        if (header.disabled) {
          return
        }
        header.default = !header.default
        if (header.default) {
          this.selectedHeaders.push(header)
        } else {
          this.selectedHeaders.splice(this.selectedHeaders.indexOf(header), 1)
        }
      }
    },
    computed: {
      columnOptions () {
        if (this.localColumnSearch) {
          return this.options.headers.filter(item => item.text && item.text.toLowerCase().includes(this.localColumnSearch.toLowerCase()))
        }

        return this.options.headers
      }
    },
    watch: {
      filter (newVal) {
        // suche hat sich geändert --> seite resetten
        this.pagination.page = 1
        this.loadData()
      },
      tableOptions (newVal, oldVal) {
        if (newVal.itemsPerPage !== oldVal.itemsPerPage) {
          // seite resetten
          this.pagination.page = 1
        }
        this.loadData()
      }
    }
  }
</script>

<style scoped>
    .maxHeight {
        max-height: 350px;
    }
</style>
